import CenterTextBanner from './center_text/CenterText';
import VideoBanner from './video_banner/VideoBanner';
import ImageBackgroundCta from './image_background_cta/ImageBackgroundCta';
import BannerGeneric from './banner_generic/BannerGeneric';
import MattressBanner from './mattress_banner/MattressBanner';

export default async function BannerContent({ block, position }) {
  const { modular_blocks } = block?.banner?.reference?.[0] ?? {};

  if (!modular_blocks || modular_blocks.length === 0) {
    console.warn(
      '[BannerContent] No modular blocks found in the banner reference.'
    );
    return null;
  }

  return (
    <>
      {modular_blocks.map((block, index) => {
        switch (Object.keys(block)[0]) {
          case 'center_text':
            return (
              <CenterTextBanner key={index} block={block} position={position} />
            );
          case 'video_banner':
            return (
              <VideoBanner key={index} block={block} position={position} />
            );
          case 'image_background_cta':
            return (
              <ImageBackgroundCta
                key={index}
                block={block}
                position={position}
              />
            );
          case 'banner_generic':
            return (
              <BannerGeneric key={index} block={block} position={position} />
            );
          case 'mattress_banner':
            return (
              <MattressBanner key={index} block={block} position={position} />
            );
          default:
            return <div key={index} className="empty-component"></div>;
        }
      })}
    </>
  );
}
